import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import { Location } from '@angular/common';

/**
 * Top bar shared by other components
 */

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  encapsulation : ViewEncapsulation.None // otherwise it seems we have conflicts with bootstrap
})
export class TopBarComponent {

  @Input()
  public title = '';

  @Input()
  public showBackButton = false;

  @Input() showDeleteButton = false;

  @Output() clickDeleteButton = new EventEmitter();

  @Input()
  public themeClass = '';

  constructor(private location: Location) { }

  /**
   * Return to the previous route
   */
  private clickGoBack() {
    window.scrollTo(0, 0);
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/top-bar/top-bar.component.ts